import { compact, map } from 'lodash';
import { toUUID } from '../../util/transform';
import type { ITicketSharedWith } from './TicketSharedWith.interface';
import TicketSharedWithClientProfile from './TicketSharedWithClientProfile';

export default class TicketSharedWith implements ITicketSharedWith {
  idClients: Array<string>;
  idClientsWithAccess: Array<string>;
  clientsLogIn: Array<string>;
  clientsLogInHistory: Array<any>;
  clientProfile: Array<TicketSharedWithClientProfile>;

  static build = (data: ITicketSharedWith) => new TicketSharedWith(data);
  static blank = () => new TicketSharedWith();

  /**
   * Constructor
   * @param {ITicketSharedWith} data
   */
  constructor(data?: ITicketSharedWith) {
    this.idClients = compact(map(data?.idClients, (obj) => toUUID(obj)));
    this.idClientsWithAccess = compact(map(data?.idClientsWithAccess, (obj) => toUUID(obj)));
    this.clientsLogIn = compact(map(data?.clientsLogIn, (obj) => toUUID(obj)));
    this.clientsLogInHistory = data?.clientsLogInHistory || [];
    this.clientProfile = map(
      data?.clientProfile,
      (obj) => new TicketSharedWithClientProfile(obj)
    );
  }
}
